export default __webpack_public_path__ + "static/media/myResumeFs.3c915cd4.pdf";